<template>
  <loading-progress v-if="!ready" />
  <div v-else-if="user && isAuthorized" class="white">
  <div id="userView" class="row">
    <div class="nav-actions">
      <button
      @click="$_goToAdmin()"
      class="btn-flat waves-effect waves-light  backButton">
    <i class="material-icons grey-text left">arrow_back</i>
      Back
    </button>
    <button
      :disabled="!pdfLink"
      @click="$_download()"
      class="btn-flat right waves-effect waves-black white">
     
      Download PDF
       <i class="material-icons grey-text right" :disabled="isProcessing">download</i >
    </button>

    </div>
    <div class="col s12 user-container">
          <div class="user-page-title " v-html="user.title.rendered"></div>
          <div class="col s12 no-padding full"  v-if="userObject" style="margin-top:0px;">
            <div class="col no-padding"><b>School</b> : {{ userObject.homeProfile.name_of_school }}</div>
            <div class="col"><b>Form</b> : {{ userObject.homeProfile.school_form }}</div>
          </div>
    </div>

    <div class="col s12">
      <survey-review-component
        :data-user-surveys="userSurveys"
        :data-user="user"
      />
    </div>
  </div>
 </div>
  <div v-else class="emptyState">
    <empty-state-component
      :showButton="true"
      buttonText="Dashboard"
      stateTitle="Access Denied"
      dataIcon="lock"
      @action="$_goToAdmin"
    >
      <template #header
        >User may not exist or is not associated with your school.</template
      >
    </empty-state-component>
  </div>
</template>

<script>
import energyIcon from "@/assets/energy_calculator.svg";
import waterPpl from "@/assets/water_shortage.svg";
import homeImage from "@/assets/home_profile.svg";
import realOverview from "@/assets/overview_image.svg";
import windHazard from "@/assets/wind-hazard@2x.png";
import floodHazard from "@/assets/flood-hazard@2x.png";
import SurveyReviewComponent from "./surveyReview.component.vue";
import reviewSurveyCard from "@/components/admin/reviewSurveyCard.vue";
import reviewSurveyCardEnergy from "@/components/admin/reviewSurveyCardEnergy.vue";
import EmptyStateComponent from "../emptyState.component.vue";
import LoadingProgress from "../loadingProgress.vue";
import { getSurveys } from "@/api/survey.api";
import * as util from "@/common/util";
import { mapState } from "vuex";
import Cookies from "js-cookie";
import { getSurveyUser } from "@/api/user.api";
import axios from "axios";
import schools from "@/JsonSchemas/schoolList";

// Just temporarily

const getUserProfile = async (id, token) => {
  let url = `https://api.sldb.lc/wp-json/wp/v2/profiles/?author=${id}&context=edit`;
  return axios.get(url, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

export default {
  name: "userView",
  props: {},
  components: {
    SurveyReviewComponent,
    EmptyStateComponent,
    reviewSurveyCardEnergy,
    reviewSurveyCard,
    LoadingProgress,
  },
  data() {
    const vm = this;
    return {
      prevRoute: false,
      isProcessing: false,
      selectedSurvey: null,
      csvData: null,
      homeImages: null,
      surveysInfo: [
        {
          key: "home-profile",
          title: "Home Profile",
          thumbnail: homeImage,
          tag: "homeProfile",
        },

        {
          key: "wind-hazard",
          title: "Wind Hazard Assessment",
          thumbnail: windHazard,
          tag: 38,
        },
        {
          key: "flood-hazard",
          title: "Flood Hazard Assessment",
          thumbnail: floodHazard,
          tag: 39,
        },
        {
          key: "water-hazard",
          title: "Water Shortage Hazard Assessment",
          thumbnail: waterPpl,
          tag: 40,
        },
        {
          key: "energy-calculator",
          title: "Household Carbon Footprint Calculator",
          thumbnail: energyIcon,
          tag: "energyCalculator",
        },
        {
          key: "assessment-summary",
          title: "Climate Change Home Risk Assessment Summary",
          thumbnail: realOverview,
          tag: 10,
        },
      ],
      ready: false,
      showUnauthorizedState: false,
      modal: {
        instance: null,
        options: {
          onCloseEnd: () => {
            vm.selectedSurvey = null;
          },
        },
      },
    };
  },
  computed: {
    ...mapState({
      users: (state) => state.Admin.users,
      surveys: (state) => state.Admin.surveys,
      profiles: (state) => state.Admin.profiles,
    }),
    isAdmin() {
      if (!this.$store.state.User.user) return false;
      const allowedRoles = ["administrator"];
      const userRoles = this.$store.state.User.user.roles;
      if (!userRoles) return false;

      const isAllowed = userRoles.reduce((result, item) => {
        if (!result) {
          result = allowedRoles.some((role) => role === item);
        }
        return result;
      }, false);

      return isAllowed;
    },

    userObject: {
      get() {
        if (this.user) {
          const { competition_entry } = this.user.acf;
          if (!competition_entry) return false;
          const compEntry = JSON.parse(competition_entry);

          if (
            (typeof compEntry === "object" &&
              Object.keys(compEntry).length <= 0) ||
            !compEntry
          )
            return false;

          return {
            homeProfile: compEntry,
          };
        }
      },
    },

    isAuthorized() {
      if (this.isPdf) return true;
      if (this.isAdmin) return true;
      return false;
    },
    isPdf() {
      const params = new URLSearchParams(document.location.search);
      const first = params.get("2b0d7b3dcb6d");
      if (first === "false") {
        return true;
      }
      return false;
    },
    user() {
      const id = parseInt(this.$route.params.id);
      // return false;
      return this.profiles.find((x) => x.author == id);
    },
    pdfLink() {
      if (!this.user) return false;
      const { acf } = this.user;
      return acf && acf.pdf;
    },
    userSurveys() {
      return this.surveys.filter(
        (x) => x.author === parseInt(this.$route.params.id)
      );
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.name;
    });
  },
  beforeRouteLeave(to, from, next) {
    next();
    this.$store.commit("Admin/RESET_DEFAULT");
  },

  created() {
    if (this.user) {
      this.ready = true;
    }
  },

  mounted() {
    this.$_getUserInfo();
  },
  methods: {
    async $_getUserInfo() {
      if (this.user) return;
      try {
        const token = Cookies.get("token");

        if (!token) throw "error";

        const { data } = await getUserProfile(this.$route.params.id, token);

        if (!data.length) throw "error";

        const { data: surveys } = await getSurveys(this.$route.params.id);

        this.$store.commit("Admin/ADD_USER", data[0]);
        this.$store.commit("Admin/ADD_PROFILE", data[0]);
        this.$store.commit("Admin/SET_SURVEYS", surveys);
        this.ready = true;
      } catch (error) {
        console.log(error);
        this.ready = true;
      }
    },
    $_goToAdmin() {
      if (this.prevRoute) {
        this.$router.back();
      } else {
        this.$router.push({ name: "admin" });
      }

      this.$emit("reset");
    },
    download(url, filename) {
      fetch(url).then(function(t) {
        return t.blob().then((b) => {
          var a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", filename);
          a.click();
        });
      });
    },
    async $_download() {
      if (this.isProcessing || !this.pdfLink) return;
      this.isProcessing = true;

      try {
        this.download(`${util.APP_URL}/${this.pdfLink}`, `survey-${slug}.pdf`);
      } catch (error) {
        this.isProcessing = false;

        util.toastMessage("Fail to download pdf. Try again");
      }
    },
  },
};
</script>
<style lang="scss" scoped>

#userView {
  max-width: 768px;
  padding-top: 24px;
  margin: 0 auto;
/*   margin-bottom: 80px; */
  .user-page-title {
    font-size: 24px;
  }
}
.survey-list {
  padding: 0 !important;
  display: flex;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    overflow-x: scroll;
    .s4 {
      min-width: 264px !important;
    }
  }
}
.survery-tab-survey-card {
  &.card {
    height: calc(100% - 1.5rem);
    min-height: 220px;
    border-radius: 10px;
    /* 	overflow: hidden; */
    .card-image {
      a {
        height: 100%;
      }
      height: 140px;
      @media screen and (min-width: 1024px) {
        height: 140px;
      }
      width: 100%;
      text-align: center;
      img {
        height: 100%;
        width: auto;
        display: inline-block;
      }
    }
    .card-content {
      .card-title {
        font-size: 15.5px;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 0px;
        cursor: pointer;
        text-transform: uppercase;
      }
    }
  }
}
</style>
<style lang="scss">
.show-on-print {
  display: none;
}
@media print {
  @page {
    size: auto;   /* auto is the initial value */ 
/*     margin: 25mm 25mm 25mm 25mm;   */
  }
  body {
     size: auto;
    margin: 0;
    background: red !important;
  }
  .dashboard {
  /*   background: transparent !important; */
  }
  #userView {
    margin-top:0px;
    padding-top:0px;
    max-width: 100% !important;
  }
  nav, .nav-actions, .navbar-fixed {
    display: none;
  }
  body {
    margin:0px !important; 
    padding: 0px !important;
  }
  .show-on-print {
    display: inherit !important;
  }
  .hide-on-print {
    display: none !important;
  }

}
.emptyState {
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}
</style>
